var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, select, takeEvery } from "redux-saga/effects";
import { CONFIG } from "../../config/app.config";
import logger from "../../logger";
import { showAlert } from "../../utils/alert/alert.utils";
import { getMessageForError } from "../../utils/error.utils";
import { generateSaga } from "../generators/generator.saga";
import { getTaskCommentsStart, getTaskCommentsSucceeded, getTaskCommentsFailed, addTaskCommentStart, addTaskCommentSucceeded, addTaskCommentFailed, deleteTaskCommentStart, deleteTaskCommentSucceeded, deleteTaskCommentFailed, } from "./task.actions";
import * as tasksApi from "./task.api";
import { GENERATOR_PARAMS } from "./task.constants";
import { getTaskComments as getTaskCommentsSelectors, isCommentsExhausted, } from "./task.selectors";
import { getNextCommentsPage } from "./task.utils";
export function getCommentsStartFlow(action) {
    var _a, taskId, limit, refetch, onSuccess, onFailure, state, comments, pageSize, _b, result, meta, isExhausted, unknownError_1, error;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, taskId = _a.taskId, limit = _a.limit, refetch = _a.refetch, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                return [4 /*yield*/, select()];
            case 1:
                state = _c.sent();
                comments = getTaskCommentsSelectors(state, taskId);
                pageSize = limit || CONFIG.DEFAULT_FETCH_LIMIT;
                if (!(!refetch && isCommentsExhausted(state, taskId))) return [3 /*break*/, 3];
                return [4 /*yield*/, put(getTaskCommentsSucceeded.getAction({
                        taskId: taskId,
                        result: [],
                        refetch: refetch,
                        isExhausted: true,
                    }))];
            case 2:
                _c.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess([]);
                return [2 /*return*/];
            case 3:
                _c.trys.push([3, 6, , 8]);
                return [4 /*yield*/, call(tasksApi.getTaskComments, taskId, refetch ? 1 : getNextCommentsPage((comments || []).length, pageSize), pageSize)];
            case 4:
                _b = _c.sent(), result = _b.items, meta = _b.meta;
                isExhausted = meta.currentPage >= meta.totalPages;
                return [4 /*yield*/, put(getTaskCommentsSucceeded.getAction({
                        taskId: taskId,
                        result: result,
                        refetch: refetch,
                        isExhausted: isExhausted,
                    }))];
            case 5:
                _c.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(result);
                return [3 /*break*/, 8];
            case 6:
                unknownError_1 = _c.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(getTaskCommentsFailed.getAction({
                        taskId: taskId,
                        error: error,
                    }))];
            case 7:
                _c.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                showAlert({
                    type: "error",
                    message: getMessageForError(error),
                });
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function addCommentsStartFlow(action) {
    var _a, taskId, content, onSuccess, onFailure, result, unknownError_2, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, taskId = _a.taskId, content = _a.content, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(tasksApi.addTaskComment, {
                        taskId: taskId,
                        content: content,
                    })];
            case 2:
                result = _b.sent();
                return [4 /*yield*/, put(addTaskCommentSucceeded.getAction({
                        taskId: taskId,
                        comment: result,
                    }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(result);
                return [3 /*break*/, 6];
            case 4:
                unknownError_2 = _b.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [4 /*yield*/, put(addTaskCommentFailed.getAction({
                        taskId: taskId,
                        error: error,
                    }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                showAlert({
                    type: "error",
                    message: error.message,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function deleteCommentsStartFlow(action) {
    var _a, taskId, commentId, onSuccess, onFailure, unknownError_3, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, taskId = _a.taskId, commentId = _a.commentId, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(tasksApi.deleteTaskComment, {
                        commentId: commentId,
                    })];
            case 2:
                _b.sent();
                return [4 /*yield*/, put(deleteTaskCommentSucceeded.getAction({
                        taskId: taskId,
                        commentId: commentId,
                    }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                return [3 /*break*/, 6];
            case 4:
                unknownError_3 = _b.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [4 /*yield*/, put(deleteTaskCommentFailed.getAction({
                        taskId: taskId,
                        commentId: commentId,
                        error: error,
                    }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                showAlert({
                    type: "error",
                    message: error.message,
                });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
export function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(getTaskCommentsStart.type, getCommentsStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(addTaskCommentStart.type, addCommentsStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(deleteTaskCommentStart.type, deleteCommentsStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, generateSaga(GENERATOR_PARAMS)];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
